module.exports = __webpack_public_path__ + "img/virgin-media-3769252.png";